import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define('team_member', { name: '' })
